<template>
  <el-dialog
    v-model="visible"
    title="Actualizar contraseña"
    width="22%"
    center
    @close="closeModal"
  >
    <el-form
      ref="formRef"
      :model="user"
      :rules="formRules"
      size="default"
    >
      <el-row :gutter="20">
        <el-form-item
          prop="Password"
          class="full-width"
        >
          <el-input
            v-model="user.Password"
            type="password"
            placeholder="Ingresar contraseña"
            show-password
          />
        </el-form-item>
        <el-form-item
          prop="RepetirPassword"
          class="full-width"
        >
          <el-input
            v-model="user.RepetirPassword"
            style="margin-top: 4%"
            type="password"
            placeholder="Repetir contraseña"
            show-password
          />
        </el-form-item>
      </el-row>
    </el-form>
    <template v-slot:footer>
      <span class="dialog-footer">
        <el-button
          type="primary"
          @click="saveUser"
          >Guardar</el-button
        >
        <el-button @click="closeModal">Cancelar</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import {
  ref,
  reactive,
} from 'vue';
import { storeToRefs } from 'pinia';
import { useUserStore } from '../stores/user_store.js';
import { useMessageError } from '@/shared/composables/message_error.js';
import { useMessageSuccess } from '@/shared/composables/message_success.js';
import { useLoading } from '@/shared/composables/loading.js';
import { ElNotification } from 'element-plus';

const userStore = useUserStore();
const { resetUser, changePassword, firstUsers } = userStore;

const { user } = storeToRefs(userStore);
const visible = ref(false);
const formRef = ref(null);
const formRules = reactive({
  Password: [
    { message: 'Ingresar contraseña', trigger: 'blur' },
    { min: 4, message: 'La contraseña debe tener al menos 4 caracteres', trigger: 'blur' },
  ],
  RepetirPassword: [
    { message: 'Repetir la contraseña', trigger: 'blur' },
    { validator: validarCoincidenciaContraseña, trigger: 'blur' },
  ],
});

function validarCoincidenciaContraseña(rule, value, callback) {
  // Si ambos campos están vacíos, se asume que no se desea cambiar la contraseña y no se muestra error
  if (user.value.Password === '' && value === '') {
    callback();
  } else if (user.value.Password !== value) {
    callback(new Error('Las contraseñas no coinciden'));
  } else {
    callback();
  }
}
const emit = defineEmits(['closed']);

const closeModal = () => {
  resetFormValidation();
  visible.value = false;
  emit('closed');
};

const resetFormValidation = () => {
  if (formRef.value) {
    formRef.value.resetFields();
  }
};

const saveUser = async () => {
  formRef.value.validate(async (valid) => {
    if (valid) {
      try {
        useLoading().openLoading();
        if (
          user.value.Password !== undefined &&
          user.value.Password !== null &&
          user.value.Password !== '' &&
          user.value.RepetirPassword !== undefined &&
          user.value.RepetirPassword !== null &&
          user.value.RepetirPassword !== ''
        ) {
          await changePassword();
          useMessageSuccess().open(`La contraseña se actualizó existosamente!`);
        }
        closeModal();
      } catch (err) {
        useMessageError().open(`Ha ocurrido un error al intentar guardar los datos.`);
      } finally {
        useLoading().closeLoading();
        closeModal();
      }
    } else {
      ElNotification({
        title: 'Nuevo usuario',
        message: 'Por favor, revise los campos ingresados.',
        type: 'warning',
      });
    }
  });
};
</script>

<style scoped>
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  margin: 5%;
}

.el-form {
  margin-top: 0;
}

/* Elimina los márgenes de los el-form-item */
.el-form-item {
  margin-top: 0;
  margin-bottom: 0;
}
.input-margin {
  margin-top: 3%;
}
.full-width {
  width: 100%;
  margin: 3%;
}
.custom-label {
  font-weight: 700;
  color: #111;
}
</style>
